<template>
  <div>
    <a-card style="margin: 20px">
      <template #title>
        <div class="title-box">
          <div class="title-box-left">
            订单支付 > 协议支付
          </div>
          <div class="title-box-right">
            <a-button @click="$router.go(-1)">取消支付</a-button>
          </div>
        </div>
      </template>

      <div class="form-box">
        <!-- 付款钱包 -->
        <div class="form-box-item">
          <a-row>
            <a-col :span="4"><span>付款钱包</span></a-col>
            <a-col :span="20">
              <WalletChooseDialog style="width: 300px;"
                                  v-model="paramsData.accountName"
                                  :custname="paramsData.custname"
                                  account-class="0"
                                  :open-account-class="true"
                                  @chooseDone="onWalletChosen">
              </WalletChooseDialog>
            </a-col>
          </a-row>
        </div>

        <!-- 钱包账号 -->
        <div class="form-box-item">
          <a-row>
            <a-col :span="4"><span>钱包账号</span></a-col>
            <a-col :span="20">
              <div v-if="payerWalletList.length === 1" class="account-tag">
                <a-tag :color="payerWalletList[0].accountClass == '0' ? 'green' : 'blue'">
                  {{ payerWalletList[0].accountClass == '0' ? '活期' : '冻结' }}
                </a-tag>
                <span>{{ payerWalletList[0].accountNo }}</span>
              </div>
              <a-radio-group v-else v-model="paramsData.accountNo" @change="changeAccount">
                <a-radio-button v-for="(item, ind) in payerWalletList"
                                :key="'payerWalletList' + ind"
                                :value="item.accountNo"
                                :disabled="!$authority('A2BalanceVisible') && item.accountClass == '6'">
                  <a-tag :color="item.accountClass == '0' ? 'green' : 'blue'">
                    {{ item.accountClass == '0' ? '活期' : '冻结' }}
                  </a-tag>
                  <span>{{ item.accountNo }}</span>
                </a-radio-button>
              </a-radio-group>
            </a-col>
          </a-row>
        </div>

        <!-- 可使用余额 -->
        <div class="form-box-item">
          <a-row style="display: flex; align-items: center;">
            <a-col :span="4">
              <span>可用余额</span>
            </a-col>
            <a-col :span="4">
              <Balance :amount="balance" :align-right="false"></Balance>
            </a-col>
          </a-row>
        </div>

        <!-- 收款人 -->
        <div class="form-box-item">
          <a-row>
            <a-col :span="4"><span>收款人</span></a-col>
            <a-col :span="20">
              <a-select placeholder="请选择收款人"
                        v-model="paymentValue"
                        @change="paymentChange"
                        style="min-width: 300px;"
                        :loading="paymentLoading">
                <a-select-option v-for="item in paymentList"
                                 :key="item.id"
                                 :value="item.id">
                  <WalletInfo :account-name="item.oppAccountName"
                              :account-no="item.oppAccountNo"
                              :bank-name="item.oppBankName"
                              :bank-no="item.oppBankNo"
                              :show-account-no="false"
                              :show-account-name="true"
                              :is-wallet="item.oppAccountType==='1'"
                              :show-balance="false">
                  </WalletInfo>
                  <a-tag color="red" v-if="item.checkStatus === '0'">待审批</a-tag>
                </a-select-option>
              </a-select>
              <div class="payment-box" v-if="paymentValue">
                <a-descriptions :column="1" size="small" bordered>
                  <a-descriptions-item label="收款户名">{{ paramsData.oppAccountName }}</a-descriptions-item>
                  <a-descriptions-item label="收款账号">{{ paramsData.oppAccountNo }}</a-descriptions-item>
                  <a-descriptions-item label="开户银行">{{ paramsData.oppBankName }}</a-descriptions-item>
                  <a-descriptions-item label="开户行号">{{ paramsData.oppBankNo }}</a-descriptions-item>
                </a-descriptions>
              </div>
            </a-col>
          </a-row>
        </div>

        <!-- 支付金额 -->
        <div class="form-box-item">
          <a-row>
            <a-col :span="4"><span>支付金额</span></a-col>
            <a-col :span="20">
              <input-balance v-model="paramsData.payAmount"
                             :max="maxPayAmount"
                             style="width: 300px;"
                             align-left>
              </input-balance>
            </a-col>
          </a-row>
        </div>

        <!-- 交易摘要 -->
        <div class="form-box-item">
          <a-row>
            <a-col :span="4"><span>交易摘要</span></a-col>
            <a-col :span="20">
              <a-input v-model="paramsData.remark"
                       size="small"
                       style="width: 300px;"
                       placeholder="默认税金"/>
            </a-col>
          </a-row>
        </div>

        <!-- 验证码 -->
        <div class="form-box-item">
          <a-row>
            <a-col :span="4"><span>验证码</span></a-col>
            <a-col :span="20">
              <payment-sms style="width:300px"
                           :verify-code.sync="paramsData.verifyCode"
                           :account-name="paramsData.accountName"
                           :account-no="paramsData.accountNo"
                           :pay-amount="paramsData.payAmount"
                           model-no="102216"
                           :mobile="mobile"
                           :channel-no="paramsData.channelNo"
                           :disabled="!paramsData.oppAccountNo || Number(paramsData.payAmount)<=0">
              </payment-sms>
            </a-col>
          </a-row>
        </div>

        <!-- 确认按钮 -->
        <div class="form-box-item">
          <a-row>
            <a-col :span="4"></a-col>
            <a-col :span="20">
              <div
                  style="display: flex; flex-direction: column;align-items: start; justify-content: space-between; min-height: 100px;">
                <div style="display: flex; justify-content: space-between;">
                  <a-button type="primary"
                            :disabled="!canSubmit || submitting"
                            :loading="submitting"
                            @click="onSubmitPay"
                            icon="property-safety"
                            style="width: 300px;">
                    确认支付
                  </a-button>
<!--                  <a-tooltip>-->
<!--                    <template slot="title">-->
<!--                      生成二维码,请本人确认-->
<!--                    </template>-->
<!--                    <a-button type="link"-->
<!--                              v-if="paramsData.payAmount && paramsData.oppAccountNo && !paramsData.verifyCode"-->
<!--                              @click="qrcodeBusi" icon="qrcode" style="width: 50px;">-->
<!--                    </a-button>-->
<!--                  </a-tooltip>-->
                </div>
                <a-space></a-space>
                <a-button type="link" @click="toPayOrderPage" icon="clock-circle" style="width: 300px;">历史交易
                </a-button>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>

      <!-- 确认弹框 -->
      <a-modal :visible="isShowConfirmDialog"
               centered
               @ok="onConfirmDialog"
               @cancel="isShowConfirmDialog = false"
               title="支付信息确认">
        <a-descriptions bordered :column="1">
          <a-descriptions-item label="付款账户">{{ paramsData.accountName }}</a-descriptions-item>
          <a-descriptions-item label="付款账号">{{ paramsData.accountNo }}</a-descriptions-item>
          <a-descriptions-item label="支付金额">
            <Balance :amount="paramsData.payAmount" prefix="" suffix="元"/>
          </a-descriptions-item>
          <a-descriptions-item label="支付方式">协议支付</a-descriptions-item>
        </a-descriptions>
        <a-descriptions bordered :column="1" style="margin-top: 16px;">
          <a-descriptions-item label="收款户名">{{ paramsData.oppAccountName }}</a-descriptions-item>
          <a-descriptions-item label="收款账号">{{ paramsData.oppAccountNo }}</a-descriptions-item>
          <a-descriptions-item label="开户银行">{{ paramsData.oppBankName }}</a-descriptions-item>
          <a-descriptions-item label="交易备注">{{ paramsData.remark }}</a-descriptions-item>
        </a-descriptions>
        <a-alert v-if="contract_pay_msg"
                 :message="contract_pay_msg"
                 type="warning"
                 show-icon
                 style="margin-top: 16px;"/>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import WalletChooseDialog from "@/view/components/ChooseDialog/WalletChooseDialog.vue";
import Balance from '@/view/components/Balance.vue'
import WalletInfo from "@/view/components/WalletInfo.vue";
import InputBalance from "@/view/components/InputBalance.vue";
import PaymentSms from "@/view/components/PaymentSms.vue";

const paramsData = {
  channelNo: "",
  appNo: "",
  accountNo: "",
  accountName: "",
  custname: "",
  oppAccountType: "",
  oppAccountNo: "",
  oppAccountName: "",
  oppBankNo: "",
  oppBankName: "",
  verifyCode: "",
  payAmount: "",
  remark: "",
};

export default {
  name: "TempContractPay",
  components: {
    WalletChooseDialog,
    Balance,
    InputBalance,
    WalletInfo,
    PaymentSms,
  },
  data() {
    return {
      paramsData,
      contract_pay_msg: "",
      isShowConfirmDialog: false,
      balance: 0,
      mobile_mch: "",
      payerWalletList: [],
      paymentList: [],
      paymentValue: undefined,
      paymentLoading: false,
      submitting: false,  // 提交中状态
    };
  },

  computed: {
    mobile() {
      return this.mobile_mch;
    },
    maxPayAmount() {
      return this.balance;
    },
    canSubmit() {
      return this.paramsData.payAmount &&
          this.paramsData.oppAccountNo &&
          this.paramsData.verifyCode;
    }
  },

  mounted() {
    this.getBaseConfig();
  },

  methods: {
    // 获取基础配置
    async getBaseConfig() {
      try {
        const records = await this.api.findConfigApi(["temp_contract_pay_remark", "pay_msg"]);
        if (records.code !== 200) {
          this.$message.warning(records.info);
          return;
        }
        // 配置字段名一致
        this.paramsData.remark = records.data?.temp_contract_pay_remark?.constValue ?? '税金';
        try {
          const payMsgConstValue = JSON.parse(records.data?.pay_msg?.constValue || '{}');
          this.contract_pay_msg = payMsgConstValue?.default ?? '';
        } catch (e) {
          this.contract_pay_msg = '';
        }
      } catch (e) {
        console.error('获取基础配置失败', e);
      }
    },

    // 切换账号
    changeAccount() {
      this.getAvibaleBalance();
      this.getPaymentList();
    },

    // 选择钱包
    async onWalletChosen(walletInfo) {
      this.paramsData.channelNo = walletInfo.channelNo;
      this.paramsData.appNo = walletInfo.appNo;
      this.paramsData.accountNo = walletInfo.accountNo;
      this.paramsData.accountName = walletInfo.accountName;
      this.paramsData.custname = walletInfo.custname;

      this.payerWalletList = [{
        accountClass: walletInfo.accountClass,
        accountNo: walletInfo.accountNo
      }];

      await this.getAvibaleBalance();
      await this.getPaymentList();
    },

    // 获取余额
    async getAvibaleBalance() {
      if (!this.paramsData.accountNo) return;
      try {
        const res = await this.api.avibaleBalanceApi({
          channel_no: this.paramsData.channelNo,
          account_no: this.paramsData.accountNo,
          relation_acct: 1
        });
        if (res.code == 200) {
          this.mobile_mch = res.data.mobile;
          const acctList = res.data.detail_list.find(
              (acct) => acct.account_no === this.paramsData.accountNo
          );
          this.balance = acctList?.cur_balance || 0;
        } else {
          this.$message.error(res.info);
        }
      } catch (e) {
        console.error('获取余额失败', e);
      }
    },

    // 获取收款人列表
    async getPaymentList() {
      if (!this.paramsData.accountNo) return;
      this.paymentLoading = true;
      try {
        const res = await this.api.getPayProtocolListApi({
          pageNo: 1,
          pageSize: 10000,
          obj: {accountNo: this.paramsData.accountNo}
        });
        if (res.code === 200) {
          this.paymentList = res.data.records || [];
          // 默认选中第一个已审批的收款人
          const defaultOppAcct = this.paymentList.find((item) => item.checkStatus === '1');
          if (defaultOppAcct) {
            this.paymentValue = defaultOppAcct.id;
            this.paymentChange(defaultOppAcct.id);
          }
        }
      } catch (e) {
        console.error('获取收款人列表失败', e);
      } finally {
        this.paymentLoading = false;
      }
    },

    // 选中收款人
    paymentChange(value) {
      if (!value) return;
      const paymentData = this.paymentList.find((item) => item.id == value) || {};
      this.paramsData.oppAccountType = paymentData.oppAccountType;
      this.paramsData.oppAccountNo = paymentData.oppAccountNo;
      this.paramsData.oppAccountName = paymentData.oppAccountName;
      this.paramsData.oppBankNo = paymentData.oppBankNo;
      this.paramsData.oppBankName = paymentData.oppBankName;
    },

    // 提交支付
    onSubmitPay() {
      if (!this.paramsData.payAmount) {
        return this.$message.error("请输入支付金额");
      }
      if (!this.paramsData.verifyCode) {
        return this.$message.error("请填写验证码");
      }
      this.isShowConfirmDialog = true;
    },

    // 确认支付
    onConfirmDialog() {
      this.isShowConfirmDialog = false;
      this.doPay();
    },

    // 执行支付
    async doPay() {
      this.submitting = true;
      try {
        const data = {
          ...this.paramsData,
          payAmount: Number(this.paramsData.payAmount),
          payType: '300310-2'
        };
        const res = await this.api.tempCommonPayApi(data);
        if (res.code == 200) {
          this.$message.success(res.info || '支付成功');
          this.resetForm();
          this.$router.push({name: "tempContractPay"});
        } else {
          this.$message.error(res.info || '支付失败');
        }
      } catch (e) {
        console.error('支付失败', e);
        this.$message.error('支付请求异常');
      } finally {
        this.submitting = false;
      }
    },

    toPayOrderPage() {
      this.$router.push({
        path: "/biz/payOrder",

      });
    },
    // 重置表单
    resetForm() {
      this.paramsData.payAmount = '';
      this.paramsData.verifyCode = '';
      this.paramsData.oppAccountNo = '';
      this.paramsData.oppAccountName = '';
      this.paramsData.oppAccountType = '';
      this.paramsData.oppBankNo = '';
      this.paramsData.oppBankName = '';
      this.paymentValue = undefined;
      this.balance = 0;
      this.paymentList = [];
    },
  }
}
</script>

<style lang="less" scoped>
.title-box {
  display: flex;
  justify-content: space-between;
}

.form-box {
  padding: 50px;

  .form-box-item {
    margin-bottom: 20px;

    .account-tag {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      padding: 4px 12px;
      background: #f5f5f5;
      border-radius: 4px;
    }

    .ant-select {
      min-width: 300px;
    }

    .ant-input {
      max-width: 300px;
    }

    .payment-box {
      width: 450px;
      margin-top: 10px;
    }
  }
}
</style>